export interface Country {
    name?: string;
    code?: string;
}

export interface Representative {
    name?: string;
    image?: string;
}

export interface Customer {
    id?: number;
    name?: string;
    country?: Country;
    company?: string;
    date?: string;
    status?: string;
    activity?: number;
    representative?: Representative;
}

export interface Accredited {
    userId: number;
    code: string;
    name: string;
    accDesId: number;
}

export interface GridData {
    logo1: any,
    logo2: any,
    arrayIndex: number,
    gmwbId: number,
    productid: number,
    productName: string,
    companyid: number,
    companyName: string,
    riderName: string,
    minAge: number,
    maxAge: number,
    riderFee: number,
    rollupPer: number,
    withdrawalPer: number,
    riderFeeJoint: number,
    rollupPerJoint: number,
    withdrawalPerJoint: number,
    maxRollupYears: number,
    isCaseAOrC: string,
    ageBand1: number,
    ageBand2: number,
    purchasePayBonus: string,
    internalName: string,
    bonusPercentage: number,
    bonusName: string,
    factorSingle: number,
    factorJoint: number,
    premiumBonus: any,
    id: number,
    otherVariable: string,
    bbBonus: any,
    groupId: number,
    groupName: string,
    bestid: string,
    surryr: number,
    strategyFee: number,
    gender: string,
    bonusCaseId: number,
    bonusCaseName: string,
    availStateException: string,
    exceptions: string,
    rollupIsSimpleComp: number,
    gmwbAvailStateExceptions: string,
    riderFeedata: any,
    chargeBasisName?: string,
    highAnnivValStepup?: string,
    anualIncom: number,
    IncomePeriod: string,
    rollUp: any,
    withdrawal: any,
    isChecked: boolean,
    benifitBaseType: string,
    isCollapsed: boolean,
    waitingTerm?: string | undefined | null,
    waitingPeriod?: number | undefined | null,
    chargeFreqDeductedWhen?: string | undefined | null,
    rollUpdata?: any,
    rollupYears?: string,
    marketingName?: string,
    isShelfProduct: boolean,
    bonusPercentageBasis?: string | undefined | null,
    isGmwbBonusBenefitBase: boolean,
    isBonusBenefitBase: boolean,
    isGmwbBonusAccountValue: boolean,
    isBonusAccountValue: boolean,
    initialBenefitBase: number
}

export enum UserTypeId {
    BeaconUser = 14
}